// extracted by mini-css-extract-plugin
export default {"blog__header":"Blog_blog__header__mtwEQ","blog__likes":"Blog_blog__likes__GtMec","blog__footer":"Blog_blog__footer__wIsyC","blog__buttonGroup":"Blog_blog__buttonGroup__Wy3kf"};